export enum DEMAND_FIELDS {
	PIECES = 'pieces',
	FILES = 'files',
	ID_PIECE = 'idPiece'
}


export type SuivieDemandeLocationState = {
	scrollToDemandeEnAttente?: boolean
}

export type PieceBean = {
	files: any[],
	idPiece: number
}

export type DemandeBean = {
	id: number,
	idDemande: number,
	idDevis: string,
	numbene: number,
	beneficiaire: any,
	numDemandeur?: number,
	demandeur?: any,
	documents: DocumentBean[],
	documentsEnAttente: DocumentEnAttenteBean[],
	etat: EtatBean,
	libelle: string,
	dateDemande: string,
	dateDernierEtat: string,
	contenuMail?: string
}

export type DocumentBean = {
	url: string,
	libPiece: string,
	numdoc: string,
	iddoc: string,
	commentaire?: string
	aConsulter?: boolean
}

export type DocumentEnAttenteBean = {
	idPiece: number,
	contexte: number,
	noPiece: number,
	libPiece: string,
	entite?: number,
	commentaire?: string
}

export type EtatBean = {
	libelleEtat: string,
	icon: string,
	couleur: string
}
